import React, { useEffect, useState } from 'react';
import { Box, FormControl, FormHelperText, Typography } from '@material-ui/core';
import { arrayOfNumbers } from "../../../services/util.service";
import useStyles from './Menopause.style'
import { AppSelect, AppToggleButton, AppToggleButtonGroup } from './InputComponents';
import { menopauseReasons, menopauseStatus, menopauseSymptons } from '../../../data/db';
import menopauseIcon from '../../../images/icon_menopause.png';

const Menopause = props => {

    const classes = useStyles();
    const [autoUpdate, setAutoUpdate] = useState(false);

    const currentAge = new Date(Date.now()).getFullYear() - new Date(props.dateOfBirth).getFullYear();

    const isMenopauseSymptonsChecked = sympton => {
        return props.selectedMenopauseSymptons.includes(sympton);
    };


    useEffect(() => {
        if (props.menopause === "No") {
            if (props.direction === 'backward') {
                props.back();
            }
            else {
                props.next();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        props.validator.purgeFields();
        setAutoUpdate(!autoUpdate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.menopause, props.menopauseReason, props.menopauseStatus]);

    return (
        <Box className={classes.root}>

            <Box className={classes.textIcon} style={{ textAlign: "center" }}>
                <img src={menopauseIcon} alt="logo" />
            </Box>
            <Typography variant="h4" className={classes.title}>Menopause</Typography>
            <Typography className={classes.subTitle}></Typography>
            {props.error && !props.validator.allValid() &&
                <Typography color="error">
                    Please review your answers
                </Typography>
            }

            {/* Menopause YES */}
            <Box display={props.menopause === 'Yes' ? 'block' : 'none'}>
                {/* Menopause Age */}
                <Box className={classes.inputSection}>
                    <Typography variant="h5">What age did you begin menopause?
                    {
                     <span className={props.error && !props.validator.fieldValid('menopauseAge') ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                    }
                    </Typography>
                    <AppSelect
                        id="menopauseAge"
                        label="Age"
                        value={props.menopauseAge}
                        items={[...arrayOfNumbers(parseInt(props.firstPeriodAge), currentAge - parseInt(props.firstPeriodAge))]}
                        fullWidth
                        margin="normal"
                        onChange={props.onMenopauseAgeChange}
                        error={props.error && !props.validator.fieldValid('menopauseAge')}
                        helperText={props.validator.message('menopauseAge', props.menopauseAge, `menopause:${props.menopause}`)}
                    />
                </Box>

                {/* Menopause Status */}
                <Box className={classes.inputSection}>
                    <Typography variant="h5">Where are you on your Menopausal journey?
                    {
                     <span className={props.error && !props.validator.fieldValid('menopauseStatus') ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                    }
                    </Typography>
                    <AppSelect
                        id="menopauseStatus"
                        label="Status"
                        value={props.menopauseStatus}
                        items={menopauseStatus}
                        fullWidth
                        margin="normal"
                        onChange={props.onMenopauseStatusChange}
                        error={props.error && !props.validator.fieldValid('menopauseStatus')}
                        helperText={props.validator.message('menopauseStatus', props.menopauseStatus, `menopause:${props.menopause}`)}
                    />
                </Box>

                {/* Menopause Reason */}
                <Box className={classes.inputSection}>
                    <Typography variant="h5">Menopause Reason
                    {
                     <span className={props.error && !props.validator.fieldValid('menopauseReason') ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                    }
                    </Typography>
                    <AppSelect
                        id="menopauseReason"
                        label="Reason"
                        value={props.menopauseReason}
                        items={menopauseReasons}
                        fullWidth
                        margin="normal"
                        onChange={props.onMenopauseReasonChange}
                        error={props.error && !props.validator.fieldValid('menopauseReason')}
                        helperText={props.validator.message('menopauseReason', props.menopauseReason, `menopause:${props.menopause}`)}
                    />
                </Box>
            </Box>

            {/* Menopause Unsure */}
            <Box display={props.menopause === 'Unsure' ? 'block' : 'none'}>
                <Box className={classes.inputSection}>
                    <Typography className={classes.inputSection} variant="h5">What are your top three symptoms? 

                    {
                        <span className={props.error && !props.validator.fieldValid(`selectedMenopauseSymptons`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                    }
                    </Typography>
                    <FormControl component="fieldset" error={props.error && !props.validator.fieldValid('selectedMenopauseSymptons')}>
                        <AppToggleButtonGroup>
                            {menopauseSymptons.map(symptons =>
                                <AppToggleButton
                                    key={symptons}
                                    selected={isMenopauseSymptonsChecked(symptons)}
                                    onChange={() => props.onMenopauseSymptonChanges(symptons)}
                                    name={symptons}
                                    label={symptons}
                                />
                            )}
                        </AppToggleButtonGroup>
                        <FormHelperText>
                            {props.validator.message('selectedMenopauseSymptons', props.selectedMenopauseSymptons, `menopause_unsure:${props.menopause}`)}
                        </FormHelperText>
                    </FormControl>
                </Box>

                {/* Menopause Sympton Age */}
                <Box className={classes.inputSection}>
                    <Typography variant="h5">What age did symptoms start for you?
                    {
                        <span className={props.error && !props.validator.fieldValid(`menopauseSymptonAge`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                    }
                    </Typography>
                    <AppSelect
                        id="menopauseSymptonAge"
                        label="Age"
                        value={props.menopauseSymptonAge}
                        items={[...arrayOfNumbers(parseInt(props.firstPeriodAge), currentAge - parseInt(props.firstPeriodAge))]}
                        fullWidth
                        margin="normal"
                        onChange={props.onMenopauseSymptonAgeChange}
                        error={props.error && !props.validator.fieldValid('menopauseSymptonAge')}
                        helperText={props.validator.message('menopauseSymptonAge', props.menopauseSymptonAge, `menopause_unsure_age:${props.menopause}`)}
                    />
                </Box>
            </Box>


        </Box >
    );
}

export default Menopause;